import { render, staticRenderFns } from "./FormFieldsDate.vue?vue&type=template&id=2fca16a2&scoped=true&"
import script from "./FormFieldsDate.vue?vue&type=script&lang=js&"
export * from "./FormFieldsDate.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldsDate.vue?vue&type=style&index=0&id=2fca16a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca16a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VDialog,VSpacer,VTextField})
